(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var SCROLL_STEP = 260; // roughly two thumbnail heights at 130px each

    function initThumbnailNav(controls) {
      var position = controls.getAttribute('pagination-position');
      if (position !== 'left' && position !== 'right') return;

      var container = controls.querySelector('.slideshow-controls__thumbnails-container');
      if (!container) return;

      // Enable scrolling (CSS sets overflow-y: hidden; we switch to auto here)
      container.style.overflowY = 'auto';

      // Create buttons
      var up   = document.createElement('button');
      var down = document.createElement('button');

      up.className   = 'thumb-nav thumb-nav--up';
      down.className = 'thumb-nav thumb-nav--down';
      up.setAttribute('aria-label',   'Scroll thumbnails up');
      down.setAttribute('aria-label', 'Scroll thumbnails down');
      up.type   = 'button';
      down.type = 'button';

      controls.appendChild(up);
      controls.appendChild(down);

      function updateButtons() {
        var atTop    = container.scrollTop < 2;
        var atBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 2;
        up.hidden   = atTop;
        down.hidden = atBottom;
      }

      up.addEventListener('click', function () {
        container.scrollBy({ top: -SCROLL_STEP, behavior: 'smooth' });
      });

      down.addEventListener('click', function () {
        container.scrollBy({ top: SCROLL_STEP, behavior: 'smooth' });
      });

      container.addEventListener('scroll', updateButtons, { passive: true });

      // Re-check after images load (heights may change)
      var images = container.querySelectorAll('img');
      images.forEach(function (img) {
        if (!img.complete) img.addEventListener('load', updateButtons);
      });

      updateButtons();
    }

    function initAll() {
      document.querySelectorAll(
        'slideshow-controls[thumbnails][pagination-position="left"], ' +
        'slideshow-controls[thumbnails][pagination-position="right"]'
      ).forEach(initThumbnailNav);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init after Shopify section reloads (theme editor)
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (function () {
  // Shopify's customer form is protected by an invisible CAPTCHA that hooks
  // the native submit event itself, so this can't be turned into a fetch()
  // call without losing that protection — the actual POST + redirect still
  // happens. This just shows a brief loading state on the button so the
  // click feels acknowledged instead of dead air while the CAPTCHA runs.
  function bindForm(block) {
    var form = block.querySelector('[data-email-signup-form]');
    if (!form) return;

    form.addEventListener('submit', function () {
      var button = form.querySelector('.email-signup__button');
      if (button) button.disabled = true;
      block.classList.add('is-submitting');
    });
  }

  function init() {
    document.querySelectorAll('[data-email-signup-block]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
